import { render, staticRenderFns } from "./IviewForm.vue?vue&type=template&id=e6b8052c&scoped=true&"
import script from "./IviewForm.vue?vue&type=script&lang=js&"
export * from "./IviewForm.vue?vue&type=script&lang=js&"
import style0 from "./IviewForm.vue?vue&type=style&index=0&id=e6b8052c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b8052c",
  null
  
)

export default component.exports